import { Calendar } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { Button, ButtonVariant } from '@meiuca/ui-components'
import type { VenueDetailCTAComponent } from '../../../types/sdui-arena-detail'
import { analyticsService } from '@meiuca/analytics'
import { ANALYTICS_EVENTS } from '@/constants/analyticsEvents'

interface VenueDetailCTAProps {
  config: VenueDetailCTAComponent
  venueId: string
}

export function VenueDetailCTA({ config, venueId }: VenueDetailCTAProps) {
  const navigate = useNavigate()
  const { title, subtitle, ctaText, ctaLink, ctaAction, variant = 'both', backgroundColor } = config

  const handleCTAClick = () => {
    // Track CTA click
    analyticsService.track(ANALYTICS_EVENTS.ARENA_DETAIL_BOOKING_CLICKED, {
      arena_id: venueId,
      cta_text: ctaText,
      cta_action: ctaAction || 'navigate',
      target_url: ctaAction === 'reserve' ? `/arena/${venueId}/agendamento` : ctaLink
    })

    if (ctaAction === 'reserve') {
      navigate(`/arena/${venueId}/agendamento`)
    } else if (ctaLink) {
      navigate(ctaLink)
    }
  }

  const desktopCTA = variant === 'desktop' || variant === 'both'
  const mobileCTA = variant === 'mobile' || variant === 'both'

  return (
    <>
      {/* Desktop CTA */}
      {desktopCTA && (
        <div className="hidden md:block mb-8">
          <div
            className={`rounded-2xl p-6 shadow-lg ${!backgroundColor ? 'bg-gradient-to-r from-brand-primary to-brand-secondary' : ''}`}
            style={backgroundColor ? { backgroundColor } : undefined}
          >
            <div className="flex items-center justify-between">
              <div className="text-white">
                <h3 className="text-xl font-bold mb-1">{title}</h3>
                <p className="text-white/90 text-sm">{subtitle}</p>
              </div>
              <Button
                variant={ButtonVariant.SECONDARY}
                onClick={handleCTAClick}
                className="flex items-center gap-2 px-8 py-3 text-lg whitespace-nowrap bg-white text-brand-primary hover:bg-white/90"
              >
                <Calendar className="w-5 h-5" />
                {ctaText}
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Mobile Fixed Bottom CTA */}
      {mobileCTA && (
        <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-border-light p-4 shadow-lg z-40">
          <Button
            variant={ButtonVariant.PRIMARY}
            onClick={handleCTAClick}
            className="w-full flex items-center justify-center gap-2 py-3"
          >
            <Calendar className="w-5 h-5" />
            {ctaText}
          </Button>
        </div>
      )}
    </>
  )
}
